"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('contact', {
            url: '/contact',
            template: require('../views/contact.html'),
            controller: 'ContactController',
            controllerAs: 'contact'
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/contact/config/routes.js
// module id = 451
// module chunks = 0